/* eslint-disable no-param-reassign */
import hotkeys from 'hotkeys-js';

const hideModal = (videoModal: HTMLElement, videoContent: HTMLElement): void => {
  if (videoModal) {
    videoModal.style.opacity = '0';
    videoModal.style.background = 'none';
    videoModal.style.pointerEvents = 'none';
  }
  const iframe = videoContent.querySelector('iframe');
  iframe.src = iframe.src
  
  /*iframe?.contentWindow?.postMessage(
    JSON.stringify({
      event: 'command',
      func: 'pauseVideo',
      args: [],
      id: iframe.id,
    }),
    '*',
  );*/

  hotkeys.unbind('esc');
};

const showModal = (videoModalElement: HTMLElement, videoContent: HTMLElement): void => {
  if (videoModalElement) {
    videoModalElement.style.opacity = '1';
    videoModalElement.style.background = 'rgba(0,0,0,0.2)';
    videoModalElement.style.pointerEvents = 'unset';
  }
  hotkeys('esc', () => hideModal(videoModalElement, videoContent));
};

const videoModal = {
  init: (): void => {
    //const body = document.querySelector('body');
    const videoModals = document.querySelector('.video__modal');

    if (videoModals) {
        document.body.appendChild(videoModals); 
    }

    const video = document.querySelector('.video');

    if (video) {
        const playIcon = video?.querySelector('.video__play');
        const videoModalElement = <HTMLElement>document.querySelector('.video__modal');
        const videoContent = <HTMLElement>videoModalElement?.querySelector('.video__content');

        playIcon?.addEventListener('click', () => showModal(videoModalElement, videoContent));

        videoContent?.addEventListener('click', event => {
          event.stopPropagation();
        });

        if (videoContent && videoModalElement)
          videoModalElement.addEventListener('click', () =>
            hideModal(videoModalElement, videoContent),
          );

        const closeVideo = videoContent?.querySelector('.video__close');
        closeVideo?.addEventListener('click', () => hideModal(videoModalElement, videoContent));
      }
    
  },
};

export default videoModal;
